import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import App from '@/App';
import '@/styles/main.scss';


// Get the root element
const root = document.getElementById('root');

if (!root) {
    throw new Error('Root element not found. Make sure you have a div with id="root" in your HTML.');
}

// Render the Get My News Landing Page
ReactDOM.createRoot(root).render(
    <React.StrictMode>
        <HelmetProvider>
            <App />
        </HelmetProvider>
    </React.StrictMode>
);